import { Converter } from "opencc-js";

const traditionalToSimplified = Converter({ from: "tw", to: "cn" });
const simplifiedVariantFallbacks: Record<string, string> = {
  囘: "回",
  眞: "真",
  喫: "吃"
};
const simplifiedVariantPattern = new RegExp(
  `[${Object.keys(simplifiedVariantFallbacks).join("")}]`,
  "g"
);

export function toSimplifiedChineseText(text: string) {
  return traditionalToSimplified(text).replace(
    simplifiedVariantPattern,
    (character) => simplifiedVariantFallbacks[character] ?? character
  );
}
